<template>
  <div class="page-upload">

    <div class="page-upload__info">
      <h1>Upload: <small>{{ uploadInfo.name }}</small></h1>
      <span>Expiry: {{ uploadInfo.expiry_date | toLocaleString }}</span>
    </div>

    <video-uploader
      @success="create"
      @remove="remove"
      :accessKey="accessKey"
      :fileList="fileList"
    />
  </div>
</template>

<script>
import webcall from '@/libs/webcall';
import VideoUploader from '@/components/VideoUploader';

export default {
  components: {
    VideoUploader,
  },
  props: {
    accessKey: {
      type: String,
      default: '',
    },
    uploadInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      fileList: [],
    };
  },
  mounted() {
    webcall.liftoffs.list(this.accessKey)
      .then(({ data }) => {
        this.fileList = data;
      });
  },
  methods: {
    notifyError(error) {
      this.$notify.error({
        title: 'Error',
        message: (error.data && error.data.error) || error.message || error,
      });
    },

    create(response, file, fileList) {
      const localIndex = fileList.findIndex(localFile => localFile.uid === file.uid);
      return webcall.liftoffs.create(this.accessKey, {
        name: response.name,
        file_key: response.fileKey,
      })
        .then(({ data }) => {
          this.$set(fileList, localIndex, {
            ...data,
            status: file.status,
          });
        })
        .catch((error) => {
          this.notifyError(error);
          this.$delete(fileList, localIndex);
        });
    },
    remove(file, fileList) {
      return webcall.liftoffs.delete(this.accessKey, file.id)
        .catch((error) => {
          this.notifyError(error);
          this.$set(fileList, fileList.length, file);
        });
    },
  },
  filters: {
    toLocaleString(date) {
      return new Date(date).toLocaleString();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-upload__info {
  margin-bottom: 1em;
}
.page-upload__info h1 {
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Upload.vue